var wsConnection = {

    ws: {
        wss: null,
        callbackRequests: {},
        init: function (callback) {
            if (!wsConnection.ws.wss || wsConnection.ws.wss.readyState == 3) {
                debug.log('reconnecting on init');
                try{
                    wsConnection.ws.wss = new WebSocket("ws://127.0.0.1:8090/socket");
                }catch(err){
                    if(callback){
                        callback(err);
                    }
                }
            }

            wsConnection.ws.wss.onopen = function() {
                debug.log("Connected to socket!");
                wsConnection.ws.onOpen();
            };

            // called when a message received from server
            wsConnection.ws.wss.onmessage = function (evt) {
                debug.log('onmessage');
                var resp = JSON.parse(evt.data);
                if (resp && resp.request_id != null) {
                    var requestID = resp.request_id;
                    if (wsConnection.ws.callbackRequests.hasOwnProperty(requestID)) {
                        wsConnection.ws.callbackRequests[requestID](resp.response); // do invoke callback
                        delete wsConnection.ws.callbackRequests[requestID];
                    }
                }
            };

            // called when socket connection closed
            wsConnection.ws.wss.onclose = function() {
                debug.log("Disconnected from socket!");
                //wsConnection.ws.onClose();
            };

            // called in case of an error
            wsConnection.ws.wss.onerror = function(err) {
                debug.log("ERROR!", err )
            };

            if(callback){
                wsConnection.ws.waitForConnection(callback, 1);
                //callback();
            }

        },
        onClose: function(){
            debug.log('reconnecting onclose');
            wsConnection.ws.wss = new WebSocket("ws://127.0.0.1:8090/socket");
        },
        onOpen: function(){
            debug.log('reconnecting onopen');
            wsConnection.ws.wss = new WebSocket("ws://127.0.0.1:8090/socket");
        },
        send: function (msg, callback) {

            //this.waitForConnection(function () { //To use only if something expectactions require this awaiting method for the local application to run.

                var generatedID = wsConnection.ws.generateUniqueID();
                wsConnection.ws.callbackRequests[generatedID] = callback;
                msg.request_id = generatedID;
                var stringigyMsg = JSON.stringify(msg);
                if (wsConnection.ws.wss) {
                    debug.log('send message');
                    try{
                        wsConnection.ws.wss.send(stringigyMsg);
                    }catch(err){
                        debug.log('error sending');
                    }
                }

            //}, 1000);
        },
        generateUniqueID: function() {
            return (wsConnection.ws.getUID() + wsConnection.ws.getUID() + "-" + wsConnection.ws.getUID() + "-4" + wsConnection.ws.getUID().substr(0,3) + "-" + wsConnection.ws.getUID() + "-" + wsConnection.ws.getUID() + wsConnection.ws.getUID() + wsConnection.ws.getUID()).toLowerCase();
        },
        getUID: function(){
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        },

        waitForConnection: function (callback, interval, i) {
            debug.log('waitForConnection', wsConnection.ws.wss.readyState);
            if (wsConnection.ws.wss.readyState == 1) {
                callback({status: 'success'});
            }
            else if (i == 100 /* 10 times traying connect*/){
                callback({status: 'ERR_CONNECTION_REFUSED'}); //TODO: vefiry what to do...
            }
            else {
                var that = this;

                if (i){
                    i++;
                }else{
                    i = 1;
                }

                // optional: implement backoff for interval here
                setTimeout(function () {
                    that.waitForConnection(callback, interval, i);
                }, interval);
            }
        }
    },
    init: function(callback) {
        try{
            wsConnection.ws.init(callback);

        }catch(err){
            debug.log(err);
            if (callback){
                callback(err);
            }
        }
    },
    validatePin : function (callback) {
        debug.log('ValidatePIN');

        try{
            var msg = { action: "authenticate" };
            wsConnection.ws.send(msg, callback);
        }catch(err){
            debug.log(err);
            if (callback){
                callback({status: 'ERR_CONNECTION_REFUSED'});
            }
        }


    },
    signMessage : function (callback, xml_message) {
        debug.log('SignMessage', xml_message);

        try{
            var msg = { action: "getSignedXML", xml_signature_location: 'Receita', messageXML: xml_message};
            wsConnection.ws.send(msg, callback);
        }catch(err){
            debug.log(err);
            if (callback){
                callback({status: 'ERR_CONNECTION_REFUSED'});
            }
        }


    },

    sendMessage : function () {

    }


};

(function(){
    //wsConnection.init();
}).call(this);
